export function mapValueArray<T extends { value: number }>(values: number[], objectArr: T[]): T[] {
    return values
        .map((id) => objectArr.find((x) => x.value === id))
        .filter((x) => x !== undefined) as T[];
}
